// This lib is buildable for types only to make Tamagui happy. We are not publishing
// so we don't need to respect this rule here.
// eslint-disable-next-line @nx/enforce-module-boundaries
import { createLogger } from '@bounty/utils'

export const logger = createLogger()
